export default {
  title: '닥터나우 - 비대면 진료 앱 1위 | 탈모·여드름·감기몸살·소아과 처방까지',
  description:
    '비대면 진료 1위 어플 닥터나우로 언제든 원격진료 가능! 탈모약, 여드름약, 다이어트 주사(위고비, 삭센다 등)의 최저가 약국 찾기부터 일요일 진료 가능한 소아과, 산부인과와 약 처방∙배송 서비스까지 이용해 보세요.',
  additionalMetaTags: [
    {
      name: 'publisher',
      content: '닥터나우',
    },
    {
      name: 'author',
      content: '닥터나우',
    },
    {
      name: 'copyright',
      content: '닥터나우',
    },
    {
      name: 'creator',
      content: '닥터나우',
    },
    {
      name: 'keywords',
      content:
        '비대면진료, 비대면진료앱, 비대면진료어플, 원격진료, 약배달, 약배송, 약배달어플, 약배달앱, 약배송어플, 약배송앱, 탈모약, 여드름약, 감기약, 소아과, 위고비, 이소티논, 비대면처방',
    },
  ],

  openGraph: {
    type: 'website',
    locale: 'ko_KR',
    url: 'https://doctornow.co.kr/',
    title: '닥터나우 - 비대면 진료 앱 1위 | 탈모·여드름·감기몸살·소아과 처방까지',
    site_name: 'doctornow',
    description:
      '비대면 진료 1위 어플 닥터나우로 언제든 원격진료 가능! 탈모약, 여드름약, 다이어트 주사(위고비, 삭센다 등)의 최저가 약국 찾기부터 일요일 진료 가능한 소아과, 산부인과와 약 처방∙배송 서비스까지 이용해 보세요.',
    images: [
      {
        url: 'https://media.doctornow.co.kr/og-main.png',
        width: 600,
        height: 315,
        alt: '닥터나우',
      },
    ],
  },
  twitter: {
    handle: '@doctornow',
    site: '@doctornow.co.kr',
    cardType: 'summary_large_image',
  },
};
